import { render, staticRenderFns } from "./FormularioDenuncias.vue?vue&type=template&id=07d3f431"
import script from "./FormularioDenuncias.vue?vue&type=script&lang=js"
export * from "./FormularioDenuncias.vue?vue&type=script&lang=js"
import style0 from "./FormularioDenuncias.vue?vue&type=style&index=0&id=07d3f431&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports